webpackJsonp([35783957827783],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(98);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-fluid' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row', style: { paddingTop: '2em' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Thinking about selling?'
	          ),
	          _react2.default.createElement('p', null),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Avoid negative news. Do not check prices (daily). Do not indulge in short term negative press coverage.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Get involved beyond just owning crypto. Spread adoption. Learn how to code. Quit your job and join crypto related company.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'This transformation will not happen by sitting around and watching prices go up and down.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'To get you back on track, check out what the big boys are saying:'
	            )
	          ),
	          _react2.default.createElement('iframe', { id: 'video', width: '560', height: '315', src: 'https://www.youtube.com/embed/lp5Yx34SO58', frameborder: '0', allow: 'autoplay; encrypted-media', allowfullscreen: true }),
	          _react2.default.createElement(
	            'div',
	            { id: 'disclaimer' },
	            'This page aims at giving emotional support to crypto investors. Obviously heavily under construction at this point. Get in touch:',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: 'https://bergwiese.co' },
	              'Bergwiese UG (haftungsbeschr\xE4nkt)'
	            ),
	            '.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-36ec98b821156d7fa6c8.js